module.exports = __webpack_public_path__ + "static/img/home-study-img.0917a69c.png";